<template>
  <input
    type="text"
    v-model="localAlias"
    @input="$emit('update:alias', localAlias)"
    @keyup.enter="emitFinalAlias"
    @keyup.esc="emitCancel"
    placeholder="Enter alias"
    tabindex="0"
  />
</template>

<script>
export default {
  name: 'BranchAlias',
  props: {
    alias: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localAlias: this.alias
    };
  },
  watch: {
    alias(newVal) {
      this.localAlias = newVal;
    }
  },
  methods: {
    emitFinalAlias() {
      this.$emit('alias-updated', {done: true, alias:this.localAlias.trim()});
    },
    emitCancel() {
      this.$emit('alias-updated', {done: false, alias:''});
    }
  },
  mounted() {
    this.$el.focus();
  }
};
</script>

<style scoped>
input {
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 4px;
}
</style>